import React from 'react';
import { PRIMARY_BASE } from '@amzn/ring-common-style-library/lib/colors';

export const AgentIndicator: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
        <g id='service (ea85)'>
            <path
                id='^ Name above ^'
                d='M12 11.5C10.067 11.5 8.5 9.933 8.5 8C8.5 6.067 10.067 4.5 12 4.5C13.933 4.5 15.5 6.067 15.5 8C15.5 9.933 13.933 11.5 12 11.5ZM12 5.5C10.619 5.5 9.5 6.619 9.5 8C9.5 9.381 10.619 10.5 12 10.5C13.381 10.5 14.5 9.381 14.5 8C14.5 6.619 13.381 5.5 12 5.5ZM12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM12 3C16.965 3.008 20.987 7.034 20.987 12C20.987 13.864 20.42 15.595 19.45 17.032C17.831 14.586 15.099 13.02 12 13.02C8.901 13.02 6.169 14.586 4.55 16.969C3.58 15.596 3.013 13.864 3.013 12C3.013 7.034 7.036 3.008 12 3ZM12 21C9.276 20.994 6.836 19.778 5.19 17.862C6.61 15.54 9.13 14.024 12.005 14.024C14.88 14.024 17.4 15.54 18.81 17.816C17.171 19.781 14.728 20.997 12 21Z'
                fill={PRIMARY_BASE}
            />
        </g>
    </svg>
);
